import React from 'react';

export const LoadingSpinner: React.FC<{ message?: string }> = ({ message = "Searching for businesses..." }) => (
  <div className="flex flex-col items-center justify-center p-8 text-center">
    <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mb-4"></div>
    <p className="text-lg font-semibold text-slate-300">{message}</p>
    <p className="text-slate-400 mt-1">This may take a moment.</p>
  </div>
);
